var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',[_c('div',{ref:"recaptchaContainer",staticClass:"recaptcha-container"}),(_vm.loadError)?_c('p',{staticClass:"caption error--text"},[_vm._v(" "+_vm._s(_vm.loadError)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }